import { render, staticRenderFns } from "./layoutSidebar.vue?vue&type=template&id=ca0668e2&"
import script from "./layoutSidebar.vue?vue&type=script&lang=js&"
export * from "./layoutSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports